/**
 * ORBIS Admin - Toast Notifications Store
 */

import { defineStore } from 'pinia';
import { ref } from 'vue';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
  id: number;
  message: string;
  type: ToastType;
  duration: number;
}

let toastId = 0;

export const useToastStore = defineStore('toast', () => {
  const toasts = ref<Toast[]>([]);

  function show(message: string, type: ToastType = 'info', duration = 4000) {
    const id = ++toastId;
    toasts.value.push({ id, message, type, duration });

    if (duration > 0) {
      setTimeout(() => {
        remove(id);
      }, duration);
    }

    return id;
  }

  function success(message: string, duration = 4000) {
    return show(message, 'success', duration);
  }

  function error(message: string, duration = 5000) {
    return show(message, 'error', duration);
  }

  function warning(message: string, duration = 4000) {
    return show(message, 'warning', duration);
  }

  function info(message: string, duration = 4000) {
    return show(message, 'info', duration);
  }

  function remove(id: number) {
    const index = toasts.value.findIndex(t => t.id === id);
    if (index !== -1) {
      toasts.value.splice(index, 1);
    }
  }

  function clear() {
    toasts.value = [];
  }

  return {
    toasts,
    show,
    success,
    error,
    warning,
    info,
    remove,
    clear,
  };
});

